import React from "react";
import { EnvelopCircleIconOpen } from "../../../styles/img/svg/EnvelopCircleIconOpen";
import { RightArrowIcon } from "../../../styles/img/svg/RightArrowIcon";
import NumberFormatter from "../../../_helpers/numberFormatter";
import {
  commonConstants,
  schedulePaymentsConstants,
} from "../../../_redux/_constants";
import moment from "moment/moment";
import TransferIcon from "../../../styles/img/list_sche_fund_transfer.png";
import BillPaymentIcon from "../../../styles/img/list_sche_bill_payment.png";

export const UiSchedulePaymentsSummaryCard = (props) => {
  const { schedulePaymentData, onClick } = props;

  const cardClassName =
    schedulePaymentData?.draft || schedulePaymentData?.read
      ? `df-fav-item df-bill-fav-card df-schedule-payments-card df-draft-read`
      : `df-fav-item df-bill-fav-card df-schedule-payments-card`;

  return (
    <>
      <div className={cardClassName}>
        <div className="df-fav-item__logo df-bill-fav-card__logo">
          {schedulePaymentData?.scheduledPaymentType === schedulePaymentsConstants.SCHEDULED_PAYMENT_TYPE_TRANSFER ? 
            <img src={TransferIcon} className="df-w-46" /> : <img src={BillPaymentIcon} className="df-w-46" />
          }
        </div>

        <div className="df-fav-item__title df-bill-fav-card__title">
          <h4>
            {schedulePaymentData?.references ||
              schedulePaymentData?.scheduledPaymentName}
          </h4>
          <p className="df-sec-m-card-msg-short">
            {NumberFormatter(
              schedulePaymentData?.scheduledPaymentType === schedulePaymentsConstants.SCHEDULED_PAYMENT_TYPE_TRANSFER ?
                schedulePaymentData?.amount : schedulePaymentData?.customerNearestChargeAmountInBaseCur,
              schedulePaymentData?.scheduledPaymentType === schedulePaymentsConstants.SCHEDULED_PAYMENT_TYPE_TRANSFER ?
                schedulePaymentData?.currencyAfterConvert : schedulePaymentData?.currencyBeforeConvert,
            )}
          </p>

          {schedulePaymentData?.recurringTxnStatus ===
            schedulePaymentsConstants.SCHEDULE_PAYMENTS_RECURRING_TXN_STATUS_ACTIVE && (
            <p className="df-sec-m-card-date">{`Next Scheduled Date - ${moment(schedulePaymentData?.scheduledDate).format(commonConstants.COMMON_DATE_FORMAT_DD_MMM_YYYY_SLASH)}`}</p>
          )}
          {schedulePaymentData?.recurringTxnStatus ===
            schedulePaymentsConstants.SCHEDULE_PAYMENTS_RECURRING_TXN_STATUS_COMPLETED && (
            <p className="df-sec-m-card-date">{`Last Scheduled Date - ${moment(schedulePaymentData?.scheduledDate).format(commonConstants.COMMON_DATE_FORMAT_DD_MMM_YYYY_SLASH)}`}</p>
          )}
          {schedulePaymentData?.recurringTxnStatus ===
            schedulePaymentsConstants.SCHEDULE_PAYMENTS_RECURRING_TXN_STATUS_STOPPED && (
            <p className="df-sec-m-card-date">{`Stopped Scheduled Date - ${moment(schedulePaymentData?.scheduledDate).format(commonConstants.COMMON_DATE_FORMAT_DD_MMM_YYYY_SLASH)}`}</p>
          )}
        </div>

        {schedulePaymentData.recurringTxnStatus ? (
          <div className="df-fd-account-card-wr">
            {schedulePaymentData?.recurringTxnStatus ===
              schedulePaymentsConstants.SCHEDULE_PAYMENTS_RECURRING_TXN_STATUS_COMPLETED && (
              <label className="df-lbl-success">COMPLETED</label>
            )}
            {schedulePaymentData?.recurringTxnStatus ===
              schedulePaymentsConstants.SCHEDULE_PAYMENTS_RECURRING_TXN_STATUS_ACTIVE && (
              <label className="df-lbl-pending">ACTIVE</label>
            )}
            {schedulePaymentData?.recurringTxnStatus ===
              schedulePaymentsConstants.SCHEDULE_PAYMENTS_RECURRING_TXN_STATUS_STOPPED && (
              <label className="df-lbl-canceled">STOPPED</label>
            )}
          </div>
        ) : (
          ""
        )}
        <RightArrowIcon className="df-bill-fav-card__arrow" onClick={onClick} />
      </div>
    </>
  );
};
